if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        if (evt) {
          evt.preventDefault();
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);

        /**
         * Build object from formData.
         */
        const properties = {}
        const productId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity')) || 1;
        const groupProduct = Number(formData.get('group_product'));
        const groupType = formData.get('group_type');

        for (const [key, value] of formData) {
          if (!key.includes('properties[')) {
            continue;
          }

          const property = key
            .replace('properties[', '')
            .replace(']', '');

          properties[property] = value;
        }

        const body = {
          items: [
            {
              id: productId,
              properties,
              quantity,
            },
          ],
        };

        /**
         * Add group data if it exists.
         */
        if (groupProduct) {
          body.items.push({
            id: groupProduct,
            parent_id: productId,
            properties: {
              ...properties,
              _doogma_engraving_fee: true,
            },
            quantity,
          })
        }

        if (groupType) {
          body.items[0].properties['_group_parent'] = groupType
        }

        /**
         * Add section rendering data if cart component exists.
         */
        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        /**
         * Add product form product.
         */
        this.addToCart({ body: JSON.stringify(body), id: productId });
      }

      /**
       * Add to cart.
       * @param {Object} body - Fetch body object.
       * @param {Boolean} [engraving] - Is engraving product?
       * @param {Number} id - Product variant ID being added.
       */
      addToCart({ body, engraving = false, id } = {}) {
        return new Promise((resolve, reject) => {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          config.body = body;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: id,
                  errors: response.errors || response.description,
                  message: response.message,
                });

                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

                if (!soldOutMessage) {
                  return;
                }

                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;

              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (engraving) {
                return;
              }

              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');

              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);

              } else {
                this.cart.renderContents(response);
              }

              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: id,
                cartData: response,
              });
            })
            .catch((e) => {
              console.error(e);
              reject(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');

              if (this.cart && this.cart.classList.contains('is-empty')) {
                this.cart.classList.remove('is-empty');
              }

              if (!this.error) {
                this.submitButton.removeAttribute('aria-disabled');
              }

              this.querySelector('.loading__spinner').classList.add('hidden');
              resolve();
            });
        })
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
